<template>
	<div class="ai_container">
		<Header :title="'견적서'" :onPrev="handlePrev" :isShowHome="true" :returnName="'AiEstimateList'"/>
		<div class="estimate_overview_wrapper">
			<div>
				<b class="heading_6">{{ estimateNo }}</b>
				<p class="body_8 f_gray_4">{{ estimateDate }} 기준</p>
			</div>
			<div class="button_wrapper">
					<Button
					:size="36"
					:label="'PDF로 저장'"
					:color="'gray'"
					:onClick="handlePDFDownload" />
				<Button
					:size="36"
					:label="'견적상담'"
					:onClick="() => handleConsult()" />
			</div>
		</div>
		<div class="estimate_car_info_wrapper">
			<div class="title_wrapper heading_7" @click="toggleCarInfo">
				차량 정보
				<img
					:class="`${isCarInfoOpen ? '' : 'car_info_close'}`"
					src="/static/icons/arrow/arrow_small_bold_up.svg"
					alt="arrow" />
			</div>
			<ul v-if="isCarInfoOpen">
				<li v-for="item in carInfo" :key="item.label">
					<p class="body_8 f_gray_4">{{ item.label }}</p>
					<b class="body_7_M">
						{{ item.value }}
						<span v-if="!!item.subValue" class="body_10_M f_gray_4">{{
							item.subValue
						}}</span>
					</b>
				</li>
			</ul>
		</div>
		<div>
			<div class="estimate_price_info_wrapper" >
				<Tab
					:options="[
						{ label: '공식딜러', value: 'dealer' },
						{ label: '제휴협력공장', value: 'am' },
					]"
					:activeKey="tab"
					:onChange="handleTabChange"
				/>
				<div class="title_wrapper heading_7">
					견적 내역 <span v-show="tab === 'am'" class="body_10">(딜러가 대비 <span class="body_10" style="color:#295BFF">{{diffPrice.toLocaleString()}}</span>원 저렴)</span>
				</div>
				<div class="estimate_price_list_wrapper">
					<ul>
						<li v-for="item in setPriceList()" :key="item.label">
							<p class="body_8 f_gray_4">{{ item.label }}</p>
							<b :class="`${item.discount ? 'body_7 f_red_1' : 'heading_8'}`">{{ item.discount ? "-" : ""
								}}{{ item.value.toLocaleString() }}원</b>
						</li>
					</ul>
					<div>
						<b class="heading_7">최종 견적</b>
						<b class="heading_7"> {{ setTotalPriceList() }}원 </b>
					</div>
				</div>
			</div>
			<div class="estimate_detail_wrapper">
				<Segmented
					:options="[
						{ label: '부품', value: 'part' },
						{ label: '공임', value: 'repair' },
						{ label: '도장', value: 'paint' }
					]"
					:activeKey="segmented"
					:onChange="handleQueryChange"
				/>
				<ul>
					<li v-for="item in setList()" :key="item.partNo">
						<div class="left-section">
							<div :class="`body_11_M ${getStatusColor(item.type)}`">{{item.type}}</div>
						</div>
						<div class="main-section">
							<div class="content-section">
								<!-- <p class="body_10 f_gray_4">{{ item.no }}</p> -->
								<p v-html="item.name.replace(/\n/g, '<br>')" class="heading_8"></p>
								<p v-if="!!item.price && item.price > 0" class="body_11 f_gray_3">단가
									{{item.price.toLocaleString() }}원
								</p>
								<p v-if="!!item.amount && item.amount > 0" class="body_11 f_gray_3">수량
									{{item.amount.toLocaleString() }}개
								</p>
							</div>
							<div class="price-section">
								<p class="heading_8 f_green_1">{{ (item.totalPrice).toLocaleString() }}원</p>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<div class="estimate_photo_wrapper">
			<div class="title_wrapper heading_7">
				수리 부위 사진
			</div>
			<ul>
				<li v-for="image in imageList" :key="image.id" @click="() => handleImageClick(image.id)">
					<img :src="image.src" />
				</li>
			</ul>
		</div>
		<div class="estimate_bottom_wrapper body_9">
			• 견적 전송일자에 따라 가격이 변동될 수 있어요.
		</div>
		<ImageModal v-if="!!activeImageId" :imageUrl="imageList.find(({ id }) => id === activeImageId).src"
			:onClose="handleImageModalClose" />
		<AiPdf
			v-if="isPrintHidden"
			:estimateNo="estimateNo"
			:estimateDate="estimateDate"
			:totalNetCorrected="totalNetCorrected"
			:carInfo="carInfo"
			:priceInfo="priceInfo"
			:partList="partList"
			:repairList="repairList"
			:paintList="paintList"
			:diffPrice="diffPrice"
			:imageList="imageList"
			@downloadComplete="handleDownloadComplete"
		/>
		<Alert :isVisible="isAlert.isOpenAlert" :title="isAlert.title" :primaryText="'뒤로가기'"
			:onClickPrimary="handleAlertClose" />

	</div>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config'
import Utils from '@/modules/utils'
import Header from '@/components/ai/AiHeader.vue'
import EstimateItemCard from '@/components/ai/card/AiEstimateItemCard.vue'
import Button from '@/components/ai/AiButton.vue'
import Tab from '@/components/ai/AiTab.vue'
import Segmented from '@/components/ai/AiSegmented.vue'
import ImageModal from '@/components/ai/AiImageModal.vue'
import AiPdf from '@/components/ai/AiPdf.vue';
import Alert from '@/components/ai/AiAlert.vue'

export default {
	name:'AiEstimate',
	components: {
		AppConfig,
		Utils,
		Header,
		Button,
		Tab,
		Segmented,
		EstimateItemCard,
		ImageModal,
		AiPdf,
		Alert
		// jsPDF,
		// html2canvas
	},

	data() {
		return {
			isPrintHidden: false,
			isCarInfoOpen: false,
			estimateNo: '',
			estimateDate: this.$route.params.estimateDate,
			isAlert: {
				isOpenAlert: false,
				title: ''
			},
			segmented: this.$route.query.segmented || 'part',
			tab: this.$route.query.tab || 'am',
			totalNetCorrected:'',
			dealerTotalNetCorrected:'',
			carInfo: [
			],
			priceInfo: [
				// {
				// 	label: '견적비용 환급',
				// 	value: 3500,
				// 	discount: true
				// }
			],
			partList: [
			],
			repairList: [
			],
			paintList: [
			],

			dealerPriceInfo: [
				// {
				// 	label: '견적비용 환급',
				// 	value: 3500,
				// 	discount: true
				// }
			],
			dealerPartList: [
			],
			dealerRepairList: [
			],
			dealerPaintList: [
			],
			diffPrice:0,

			imageList: [
			],
			activeImageId: ''
		}
	},
	computed: {
		estimateSeq(){
			if(Vue.$sessionStorage.get('redirectseq')){
				return Vue.$sessionStorage.get('redirectseq')
			} else {
				this.isAlert.isOpenAlert = true;
				this.isAlert.title = `비정상적인 접근입니다.`
				return;
			}
		}
	},
	mounted(){
		this.$nextTick(()=>{
			if(this.estimateSeq){
				this.getList();
			}
		})
	},
	methods: {
		getStatusColor(type) {
			switch (type) {
				case '':
					return ''
				default :
					return 'part_label f_green_1'
			}
		},

		getList(){
			let paramDatas = {estimateSeq: this.estimateSeq};
			Vue.httpClient
			.post('/m/ai/dat/estimate/view', paramDatas)
			.then((response) => {
				if (response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
					if ( response.data.result != undefined ) {
						this.setAmList(response.data.result.aiEstimateContractModel);
						this.setDealerList(response.data.result.aiDealerEstimateContractModel);
						this.diffPrice = this.dealerTotalNetCorrected - this.totalNetCorrected
						this.getImageList(paramDatas);
					}
				} else {
					if(response.data.result){
						throw new Error(response.data.message)
					} else {
						throw new Error('')
					}
				}
			})
			.catch((e)=>{
				var msg = '';
				if(e.data){
					if(e.data.result){
						msg = e.data.result.message
					}
				} else {
					msg = `오류가 발생하였습니다\n관리자에게 문의 바랍니다`
				}

				this.isAlert.isOpenAlert = true;
				this.isAlert.title = `${msg}`
			})
		},

		async getImageList (paramDatas){
			setTimeout(() => {
				Vue.httpClient
				.post('/m/ai/dat/estimate/view/image', paramDatas)
				.then((response) => {
					if (response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
						let result = response.data.result;
						this.imageList = result.map(item => ({
							id :item.seqNo,
							src : `data:${item.mimeType};base64,${item.fileContent}`,
						}));
					} else {
					}
				})
				.catch((error) => {
				});
			}, 2000);
		},

		setAmList(result){
			// let result = response.data.result;
			this.estimateNo = result.estimateItem.estimateNo
			this.estimateDate = result.estimateItem.estimateDate.slice(0,10)
			this.$sessionStorage.set('datEstimateNo',result.estimateItem.datEstimateNo);

			this.partList = result.listParts
			.filter(item => item.partUnitAmt > 0 && item.partAmt > 0) // 조건 필터링
			.map(item => ({
				no: item.partNumber,
				name: item.partDescription,
				price: Math.round(item.partUnitAmt),
				amount: Math.round(item.partQty),
				totalPrice: Math.round(item.partAmt).toLocaleString(),
				type: '외장'
			}));

			this.repairList = result.listLaber.map(item => ({
				no: item.laborPosId,
				name: item.laborDescription,
				price: Math.round(item.laborUnitAmt),
				amount: parseFloat(item.laborTime),
				totalPrice: Math.round(item.laborAmt),
				type:item.repairType.substr(0,2)
			}));

			this.paintList = result.listPaintwork.map(item => ({
				no: item.datProductId,
				name: item.paintworkDescription,
				price: Math.round(item.laborUnitAmt),
				amount: Math.round(item.laborTime),
				totalPrice: Math.round(item.laborAmt).toLocaleString(),
				type:''

			}));

			this.carInfo.push({label:'차량번호',value:result.estimateItem.carNo})
			this.carInfo.push({label:'브랜드',value:result.listCarInfo.vbrand})
			this.carInfo.push({label:'차종',value:result.listCarInfo.vtype})
			this.carInfo.push({label:'서브타입',value:result.listCarInfo.vmodel})
			this.carInfo.push({label:'차대번호',value:result.listCarInfo.vehIdentNumber})
			this.carInfo.push({label:'도장타입',value:result.listCarInfo.lacquerType})
			this.carInfo.push({label:'엔진',value:result.listCarInfo.engineDescription})

			// this.priceInfo.push({label:'부품',value:Math.round(!Utils.isEmpty(result.listSummary) && !Utils.isEmpty(result.listSummary.sparePartsCosts) && !Utils.isEmpty(result.listSummary.sparePartsCosts.allSum) ? result.listSummary.sparePartsCosts.allSum:"0")})
			// this.priceInfo.push({label:'공임',value:Math.round(!Utils.isEmpty(result.listSummary) && !Utils.isEmpty(result.listSummary.labourCosts) && !Utils.isEmpty(result.listSummary.labourCosts.totalSum) ? result.listSummary.labourCosts.totalSum:"0")})
			// this.priceInfo.push({label:'도장',value:Math.round(!Utils.isEmpty(result.listSummary) && !Utils.isEmpty(result.listSummary.lacquerCosts) && !Utils.isEmpty(result.listSummary.lacquerCosts.totalSum) ? result.listSummary.lacquerCosts.totalSum:"0")})

			this.priceInfo.push({label:'부품',value:Math.round(!Utils.isEmpty(result.estimateItem.componentAmt) ? result.estimateItem.componentAmt:"0")})
			this.priceInfo.push({label:'공임',value:Math.round(!Utils.isEmpty(result.estimateItem.laborAmt) ? result.estimateItem.laborAmt:"0")})
			this.priceInfo.push({label:'도장',value:Math.round(!Utils.isEmpty(result.estimateItem.paintworkAmt)? result.estimateItem.paintworkAmt:"0")})

			// db에서 결제이력 가져오기
			// header과 kcp pay 조인해서 금액 가져와서
			// 빼버리기
			this.priceInfo.push({
				label: '견적비용 환급',
				value: result.estimateItem.amount,
				discount: true
			})

			this.totalNetCorrected = Math.round(!Utils.isEmpty(result.estimateItem.estimateAmt)? result.estimateItem.estimateAmt:"0");
			this.totalNetCorrected = this.totalNetCorrected-result.estimateItem.amount
		},

		setDealerList(result){
			this.dealerPartList = result.listParts
			.filter(item => item.partUnitAmt > 0 && item.partAmt > 0) // 조건 필터링
			.map(item => ({
				no: item.partNumber,
				name: item.partDescription,
				price: Math.round(item.partUnitAmt),
				amount: Math.round(item.partQty),
				totalPrice: Math.round(item.partAmt).toLocaleString(),
				type:'외장'
			}));

			this.dealerRepairList = result.listLaber.map(item => ({
				no: item.laborPosId,
				name: item.laborDescription,
				price: Math.round(item.laborUnitAmt),
				amount: parseFloat(item.laborTime),
				totalPrice: Math.round(item.laborAmt),
				type:item.repairType.substr(0,2)
			}));

			this.dealerPaintList = result.listPaintwork.map(item => ({
				no: item.datProductId,
				name: item.paintworkDescription,
				price: Math.round(item.laborUnitAmt),
				amount: Math.round(item.laborTime),
				totalPrice: Math.round(item.laborAmt).toLocaleString(),
				type:''

			}));

			if(result.estimateItem){
				this.dealerPriceInfo.push({label:'부품',value:Math.round(!Utils.isEmpty(result.estimateItem.componentAmt) ? result.estimateItem.componentAmt:"0")})
				this.dealerPriceInfo.push({label:'공임',value:Math.round(!Utils.isEmpty(result.estimateItem.laborAmt) ? result.estimateItem.laborAmt:"0")})
				this.dealerPriceInfo.push({label:'도장',value:Math.round(!Utils.isEmpty(result.estimateItem.paintworkAmt)? result.estimateItem.paintworkAmt:"0")})
				this.dealerTotalNetCorrected 	= Math.round(!Utils.isEmpty(result.estimateItem.estimateAmt)? result.estimateItem.estimateAmt:"0");
			}
		},

		setList() {
			switch(this.tab){
				case 'am':
					switch (this.segmented) {
						case 'repair':
							return this.repairList
						case 'paint':
							return this.paintList
						default:
							return this.partList
					}
				case 'dealer':
					switch (this.segmented) {
						case 'repair':
							return this.dealerRepairList
						case 'paint':
							return this.dealerPaintList
						default:
							return this.dealerPartList
					}
			}
		},
		setPriceList() {
			switch(this.tab){
				case 'am':
					return this.priceInfo;
				case 'dealer':
					return this.dealerPriceInfo;
			}
		},
		setTotalPriceList() {
			switch(this.tab){
				case 'am':
					return this.totalNetCorrected.toLocaleString();
				case 'dealer':
					return this.dealerTotalNetCorrected.toLocaleString();
			}
		},
		handlePrev() {
		},

		handlePDFDownload() {
			this.isPrintHidden = true; // PDF 다운로드 기능을 위한 화면 전환
		},
		handleDownloadComplete() {
			this.isPrintHidden = false; // 다운로드 완료 후 다시 원래 화면으로 복귀
		},

		handleConsult() {
			// session 가져가기
			this.$router.push({ name: 'AiShopList'})
		},
		toggleCarInfo() {
			this.isCarInfoOpen = !this.isCarInfoOpen
		},
		handleTabChange(value) {
			this.tab = value;
		},
		handleQueryChange (key, value) {
			this.segmented = value;
			return;
			// const currentQuery = { ...this.$route.query }
			// currentQuery[key] = value

			// this.$router
			// 	.push({ path: `/ai/ai/estimate`, query: currentQuery })
			// 	// .catch(() => {})
		},

		handleImageClick(seqNo) {
			this.activeImageId = seqNo
		},
		handleImageModalClose() {
			this.activeImageId = ''
		},
		handleAlertClose() {
			this.isAlert.isOpenAlert = false;
			this.$router.push({name:'AiEstimateList'})
		},

	}
}
</script>



// WEBPACK FOOTER //
// src/views/ai/AiEstimate.vue